export const INIT_DEPS = [
  "radix-vue",
  "tailwind-variants",
  "@nuxt/fonts",
  "@nuxtjs/tailwindcss",
  "@nuxtjs/color-mode",
  "@nuxt/icon",
  "@vueuse/nuxt",
  "@tailwindcss/forms",
  "tailwindcss-animate",
];
export const INIT_DEV_DEPS = [
  "typescript",
  "prettier-plugin-tailwindcss",
  "prettier",
  "@ianvs/prettier-plugin-sort-imports",
];

export const INIT_MODULES = [
  "@nuxtjs/tailwindcss",
  "@nuxtjs/color-mode",
  "@vueuse/nuxt",
  "@nuxt/icon",
  "@nuxt/fonts",
];

export const NUXT_VERSIONS = [
  { title: "Nuxt 3", value: 3 },
  { title: "Nuxt 4", value: 4 },
];

export const PACKAGE_MANAGER_CHOICES = [
  { title: "NPM", value: "npm" },
  { title: "YARN", value: "yarn" },
  { title: "PNPM", value: "pnpm" },
  { title: "BUN", value: "bun" },
];

export const CSS_THEME_OPTIONS = [
  { title: "Zinc", value: "zinc" },
  { title: "Slate", value: "slate" },
  { title: "Stone", value: "stone" },
  { title: "Gray", value: "gray" },
  { title: "Neutral", value: "neutral" },
  { title: "Red", value: "red" },
  { title: "Rose", value: "rose" },
  { title: "Orange", value: "orange" },
  { title: "Green", value: "green" },
  { title: "Blue", value: "blue" },
  { title: "Yellow", value: "yellow" },
  { title: "Violet", value: "violet" },
];
